import React, { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { adminAuthApi } from '../services/adminApi';

const AdminApp: React.FC = () => {
  const [authed, setAuthed] = useState(false);
  // The session now lives in an httpOnly cookie, invisible to JS, so we
  // can't just check localStorage synchronously on mount anymore — the
  // only way to know if we're logged in is to ask the server.
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    adminAuthApi.me()
      .then(() => setAuthed(true))
      .catch(() => setAuthed(false))
      .finally(() => setChecking(false));
  }, []);

  const handleLogout = () => {
    adminAuthApi.logout().catch(() => {});
    setAuthed(false);
  };

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream-100 text-sm text-coffee-100">
        Chargement…
      </div>
    );
  }

  return (
    <>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      {authed
        ? <AdminDashboard onLogout={handleLogout} />
        : <AdminLogin onLogin={() => setAuthed(true)} />
      }
    </>
  );
};

export default AdminApp;
